import { connect } from 'react-redux';
import ChooseRegion from './ChooseRegion.container';
import { confirmRegionDuringActivate } from '../../../modules/SignUp';

const mapDispatchToProps = {
  goToNextPage: confirmRegionDuringActivate,
};

export default connect(null, mapDispatchToProps)(ChooseRegion);
